module.exports = __webpack_public_path__ + "static/media/HCMM454.5c9ca31d.jpg";